import React from 'react';
import moment from 'moment';
import Form from 'antd/lib/form';
import DatePicker from 'antd/lib/date-picker';
import 'antd/lib/date-picker/style/index.css';
var RangePicker = DatePicker.RangePicker;
var InputDate = function (props) { return (React.createElement(Form.Item, { label: 'Event dates', colon: false }, props.form.getFieldDecorator('date', {
    initialValue: [moment(props.initialValueStart), moment(props.initialValueEnd)],
    rules: [{
            required: true,
            message: 'Please let us know the dates for your event!',
        }],
})(React.createElement(RangePicker, { size: 'large', disabled: props.isDisabled, style: { display: 'block' } })))); };
export default InputDate;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormEventPage/FormEvent/InputDate.tsx
// module id = 1109
// module chunks = 0